<template>
  <div class="flex flex-col min-h-screen overflow-hidden">
    <!-- Site HeaderSimple -->
    <HeaderSimple />

    <!-- Page content -->
    <main class="flex-grow">
      <HeroKaradaSupport />
      <DescriptionKaradaSupport />
      <FeaturesKaradaSupport />
      <PriceKaradaSupport />
      <CustomersVoices />
      <Faqs />
      <Cta />
    </main>

    <!-- Site footer -->
    <Footer />
  </div>
</template>

<script>
import HeaderSimple from "../partials/HeaderSimple.vue"
import HeroKaradaSupport from "../partials/HeroKaradaSupport.vue"
import DescriptionKaradaSupport from "../partials/DescriptionKaradaSupport.vue"
import FeaturesKaradaSupport from "../partials/FeaturesKaradaSupport.vue"
import PriceKaradaSupport from "../partials/PriceKaradaSupport.vue"
import CustomersVoices from "../partials/CutomersVoices.vue"
import Faqs from "../partials/FaqsKaradaSupport.vue"
import Cta from "../partials/Cta.vue"
import Footer from "../partials/Footer.vue"

export default {
  name: "KaradaSupport",
  components: {
    HeaderSimple,
    HeroKaradaSupport,
    DescriptionKaradaSupport,
    FeaturesKaradaSupport,
    PriceKaradaSupport,
    CustomersVoices,
    Faqs,
    Cta,
    Footer,
  },
}
</script>
